var map = {
	"./medcare/Apple – 1.jpg": 390,
	"./medcare/Apple.jpg": 391,
	"./medcare/Avacado – 1.jpg": 392,
	"./medcare/Avacado.jpg": 393,
	"./medcare/Avocado – 1.jpg": 394,
	"./medcare/Avocado.jpg": 395,
	"./medcare/Carbs – 1.jpg": 396,
	"./medcare/Carbs.jpg": 397,
	"./medcare/Cough – 1.jpg": 398,
	"./medcare/Cough.jpg": 399,
	"./medcare/Crying – 1.jpg": 400,
	"./medcare/Crying.jpg": 401,
	"./medcare/DarkChocolate – 1.jpg": 402,
	"./medcare/DarkChocolate.jpg": 403,
	"./medcare/Fibre – 1.jpg": 404,
	"./medcare/Fibre.jpg": 405,
	"./medcare/Fish – 1.jpg": 406,
	"./medcare/Fish.jpg": 407,
	"./medcare/FruitJuice – 1.jpg": 408,
	"./medcare/FruitJuice.jpg": 409,
	"./medcare/FunExercise – 1.jpg": 410,
	"./medcare/FunExercise.jpg": 411,
	"./medcare/GoNuts – 1.jpg": 412,
	"./medcare/GoNuts.jpg": 413,
	"./medcare/GoodFoodReward – 1.jpg": 414,
	"./medcare/GoodFoodReward.jpg": 415,
	"./medcare/GreenTea – 1.jpg": 416,
	"./medcare/GreenTea.jpg": 417,
	"./medcare/Greens – 1.jpg": 418,
	"./medcare/Greens.jpg": 419,
	"./medcare/Guts – 1.jpg": 420,
	"./medcare/Guts.jpg": 421,
	"./medcare/HealthyLungs – 1.jpg": 422,
	"./medcare/HealthyLungs.jpg": 423,
	"./medcare/HomeCooking – 1.jpg": 424,
	"./medcare/HomeCooking.jpg": 425,
	"./medcare/HotShower – 1.jpg": 426,
	"./medcare/HotShower.jpg": 427,
	"./medcare/Hydrate – 1.jpg": 428,
	"./medcare/Hydrate.jpg": 429,
	"./medcare/Kiwi – 1.jpg": 430,
	"./medcare/Kiwi.jpg": 431,
	"./medcare/Laughing – 1.jpg": 432,
	"./medcare/Laughing.jpg": 433,
	"./medcare/Lingo – 1.jpg": 434,
	"./medcare/Lingo.jpg": 435,
	"./medcare/MidnightSnack – 1.jpg": 436,
	"./medcare/MidnightSnack.jpg": 437,
	"./medcare/Milk – 1.jpg": 438,
	"./medcare/Milk.jpg": 439,
	"./medcare/NoSmoking – 1.jpg": 440,
	"./medcare/NoSmoking.jpg": 441,
	"./medcare/Nuts – 1.jpg": 442,
	"./medcare/Nuts.jpg": 443,
	"./medcare/Pet – 1.jpg": 444,
	"./medcare/Pet.jpg": 445,
	"./medcare/PetAllergy – 1.jpg": 446,
	"./medcare/PetAllergy.jpg": 447,
	"./medcare/Routine – 1.jpg": 448,
	"./medcare/Routine.jpg": 449,
	"./medcare/Run – 1.jpg": 450,
	"./medcare/Run.jpg": 451,
	"./medcare/Shower – 1.jpg": 452,
	"./medcare/Shower.jpg": 453,
	"./medcare/SkippingMeals – 1.jpg": 454,
	"./medcare/SkippingMeals.jpg": 455,
	"./medcare/Sleep – 1.jpg": 456,
	"./medcare/Sleep.jpg": 457,
	"./medcare/Sleeping – 1.jpg": 458,
	"./medcare/Sleeping.jpg": 459,
	"./medcare/Snack – 1.jpg": 460,
	"./medcare/Snack.jpg": 461,
	"./medcare/Steps – 1.jpg": 462,
	"./medcare/Steps.jpg": 463,
	"./medcare/Strawberries – 1.jpg": 464,
	"./medcare/Strawberries.jpg": 465,
	"./medcare/Stretch – 1.jpg": 466,
	"./medcare/Stretch.jpg": 467,
	"./medcare/SugaryDrinks – 1.jpg": 468,
	"./medcare/SugaryDrinks.jpg": 469,
	"./medcare/Teeth – 1.jpg": 470,
	"./medcare/Teeth.jpg": 471,
	"./medcare/Tomatoes – 1.jpg": 472,
	"./medcare/Tomatoes.jpg": 473,
	"./medcare/TrackFood – 1.jpg": 474,
	"./medcare/TrackFood.jpg": 475,
	"./medcare/VaccineExercise – 1.jpg": 476,
	"./medcare/VaccineExercise.jpg": 477,
	"./medcare/VegBreakfast – 1.jpg": 478,
	"./medcare/VegBreakfast.jpg": 479,
	"./medcare/VitaminC – 1.jpg": 480,
	"./medcare/VitaminC.jpg": 481,
	"./medcare/Walking – 1.jpg": 482,
	"./medcare/Walking.jpg": 483,
	"./medcare/Water – 1.jpg": 484,
	"./medcare/Water.jpg": 485,
	"./medcare/Watermelon – 1.jpg": 486,
	"./medcare/Watermelon.jpg": 487,
	"./medcare/Writing – 1.jpg": 488,
	"./medcare/Writing.jpg": 489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 389;